"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundSwitchTracker = void 0;
var react_1 = __importDefault(require("react"));
var legacy_queries_1 = require("../../../../shared/api/legacy-queries");
var core_1 = require("../../../../shared/core");
var with_customer_and_account_ids_1 = require("../../../../shared/core/utils/with-customer-and-account-ids");
var Loading_1 = require("../../components/Loading");
var InboundSwitchTrackerUI_1 = require("./ui/InboundSwitchTrackerUI");
var Data = function (_a) {
    var supplyPoints = _a.supplyPoints, openingMeterReadings = _a.openingMeterReadings;
    var _b = (0, core_1.useComponents)(), ErrorSection = _b.ErrorSection, Tabs = _b.Tabs, TabList = _b.TabList, Tab = _b.Tab, TabPanel = _b.TabPanel, Card = _b.Card, Icon = _b.Icon;
    var onboardingSupplies = supplyPoints.filter(function (supply) {
        // Unfortunately isOnboarding doesn't cover all cases.
        return supply.isOnboarding ||
            supply.supplyPointInfo === null ||
            supply.supplyPointInfo.meterType === null;
    });
    if (onboardingSupplies.length === 0) {
        return (react_1.default.createElement(ErrorSection, { id: "no-supplies", "data-testid": "omr-no-supplies-error" }));
    }
    if (onboardingSupplies.length === 1) {
        return (react_1.default.createElement(Card, { "data-testid": "single-supply-inbound-switch-tracker-".concat(onboardingSupplies[0].fuel.toLowerCase()) },
            react_1.default.createElement(InboundSwitchTrackerUI_1.InboundSwitchTrackerUI, { supply: onboardingSupplies[0], openingMeterReadings: openingMeterReadings })));
    }
    var noOfSuppliesPerFuel = onboardingSupplies.reduce(function (acc, supply) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[supply.fuel.toLowerCase()] = acc[supply.fuel === 'Electricity' ? 'electricity' : 'gas'] + 1, _a)));
    }, { electricity: 0, gas: 0 });
    return (react_1.default.createElement(Tabs, { "data-testid": "multiple-supply-inbound-switch-tracker", fullWidth: "always" },
        react_1.default.createElement(TabList, null, onboardingSupplies.map(function (supply) { return (react_1.default.createElement(Tab, { "data-testid": "multiple-supply-inbound-switch-tracker-tab-".concat(supply.fuel.toLowerCase()), key: supply.mpxn },
            react_1.default.createElement(Icon, { name: supply.fuel.toLowerCase() }),
            " ",
            supply.fuel,
            (noOfSuppliesPerFuel.electricity > 1 ||
                noOfSuppliesPerFuel.gas > 1) &&
                " (".concat(supply.mpxn, ")"))); })),
        onboardingSupplies.map(function (supply, index) { return (react_1.default.createElement(TabPanel, { key: supply.mpxn },
            react_1.default.createElement(InboundSwitchTrackerUI_1.InboundSwitchTrackerUI, { supply: onboardingSupplies[index], openingMeterReadings: openingMeterReadings.filter(function (omr) { return omr.mpxn === supply.mpxn; }) }))); })));
};
var Error = function () {
    var ErrorSection = (0, core_1.useComponents)().ErrorSection;
    return react_1.default.createElement(ErrorSection, { id: "api-error", "data-testid": "omr-api-error" });
};
exports.InboundSwitchTracker = (0, with_customer_and_account_ids_1.withCustomerAndAccountIds)(function (_a) {
    var accountId = _a.accountId;
    var _b = (0, legacy_queries_1.useSupplyPoints)(accountId), data = _b.data, loading = _b.loading, error = _b.error;
    var openingMeterReadingsQueryResult = (0, legacy_queries_1.useOpeningMeterReadingsLegacyQuery)(accountId);
    if (error || openingMeterReadingsQueryResult.status === 'error') {
        return react_1.default.createElement(Error, null);
    }
    if (loading ||
        openingMeterReadingsQueryResult.isFetching ||
        !data ||
        openingMeterReadingsQueryResult.status === 'no-data') {
        return react_1.default.createElement(Loading_1.Loading, null);
    }
    return (react_1.default.createElement(Data, { supplyPoints: data, openingMeterReadings: openingMeterReadingsQueryResult.data }));
}, Loading_1.Loading);
